import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { ifProp } from 'styled-tools';
import { key } from 'styled-theme';

import { IconButton, Icon } from 'shared-components';
import { GuestName, T } from 'containers';
import { AppText } from 'domain/appText';

const StyledIconButton = styled(IconButton)`
  position: absolute;
  display: none !important;
  top: 0px;
  height: 30px !important;
  width: 30px !important;
  padding: 5px;
  transition: right ${key('duration')};
  border: none !important;
  opacity: 1;

  span{
    width: 20px;
    height: 20px;
  }

  &:hover {
    opacity: 0.3;
  }
`;

const ListItem = styled.li`
  position: relative;
  overflow: hidden;
  list-style: none;
  margin: 0;
  font-size: 13px;
  border-bottom: 1px solid #dae6f2;
  padding: 6px 15px;
  transition: ${key('duration')} background-color, ${key('duration')} color;

  span.done{
    display: none;
    position: absolute;
    width: 16px;
    height: 16px;
    top: 7px;
    right: 10px;

    svg{
      fill: #404040;
      stroke: #404040;
    }
  }

  ${ifProp('selected', css`
    color: #fff;
    background-color: #3078bf;

    ${StyledIconButton} {
      right: 0px;
      display: block !important;
    }
  `, css`
    &:hover {
      background-color: #f0f5fa;
      cursor: pointer;
    }
  `)}

  ${({ hasCabin, selected }) => hasCabin && !selected && css`

    span.labelName{
      opacity: .33;
    }

    span.done{
      display: block;
      opacity: .33;
    }
  `}

  ${ifProp('hidden', css`
    display: none;
  `)}
`;

class SelectGuestListEntry extends React.Component {
  static propTypes = {
    id: PropTypes.string.isRequired,
    departureId: PropTypes.string.isRequired,
    activeCabin: PropTypes.string,
    number: PropTypes.number,
    selected: PropTypes.bool,
    removeFromCabin: PropTypes.func,
    addToCabin: PropTypes.func,
    guest: PropTypes.object,
    canBeAdded: PropTypes.bool,
    filterStatus: PropTypes.bool,
    cabinsAllocated: PropTypes.bool,
    remainingBeds: PropTypes.number,
  };

  static defaultProps = {
    guest: {},
    departureId: '',
  }

  onAddClick = () => {
    const { cabinsAllocated, addToCabin, activeCabin, remainingBeds } = this.props;
    if (!cabinsAllocated) {
      if (remainingBeds > 0) addToCabin(activeCabin);
    }
  }

  onRemoveClick = (event) => {
    const { cabinsAllocated } = this.props;
    if (!cabinsAllocated) {
      event.stopPropagation();
      const { removeFromCabin, activeCabin } = this.props;
      removeFromCabin(activeCabin);
    }
  }

  render() {
    const { id, departureId, number, selected, guest, canBeAdded, filterStatus } = this.props;
    const { selectedCabin } = guest;
    const hasCabin = selectedCabin && selectedCabin[departureId];
    return (
      <T
        text={AppText.RemoveGuestTitle}
        render={removeGuestTitle => (
          <ListItem hasCabin={!!hasCabin} cabBeAdded={canBeAdded} hidden={!filterStatus} selected={selected} onClick={this.onAddClick}>
            <span className="labelName">{number}.<GuestName id={id} /></span>
            <span className="done"><Icon icon="bed" /></span>
            <StyledIconButton icon="close" onClick={this.onRemoveClick} palette="white" transparent iconHeight={20} title={removeGuestTitle} />
          </ListItem>
        )}
      />
    );
  }
}

export default SelectGuestListEntry;



// WEBPACK FOOTER //
// ./src/components/molecules/SelectGuestListEntry/index.js